export default __webpack_public_path__ + "static/media/section-hero-overlay-1.a468c1c6.svg";